export const ARTICLE_TYPES = {
  ARTIST: 'ARTIST',
  ARTWORK: 'ARTWORK',
  NEWS: 'NEWS',
  SPECIAL: 'SPECIAL',
  EVENT: 'EVENT',
  EXHIBITION: 'EXHIBITION',
};

export const ARTICLE_TYPE_LABELS = {
  ARTIST: '아티스트',
  ARTWORK: '작품',
  NEWS: '뉴스',
  SPECIAL: '스페셜',
  EVENT: '이벤트',
  EXHIBITION: '전시',
};

export const ARTICLE_TYPE_COLORS = {
  ARTIST: '#FF6B6B',
  ARTWORK: '#FFA500',
  NEWS: '#4ECDC4',
  SPECIAL: '#95E1D3',
  EVENT: '#F38181',
  EXHIBITION: '#AA96DA',
};

export function getArticleTypeLabel(type) {
  return ARTICLE_TYPE_LABELS[type] || type;
}

export function getArticleTypeColor(type) {
  return ARTICLE_TYPE_COLORS[type] || '#000000';
}

export function getArticleTypeOptions(excludeTypes = []) {
  return Object.entries(ARTICLE_TYPE_LABELS)
    .filter(([key]) => !excludeTypes.includes(key))
    .map(([key, label]) => ({
      value: key,
      label: label,
    }));
}
